module.exports = __webpack_public_path__ + "3fe19b38bb7277814e5f927d2abe2472.svg";